import { render, staticRenderFns } from "./Add-User-To-Folder.vue?vue&type=template&id=769773ea&scoped=true&"
import script from "./Add-User-To-Folder.vue?vue&type=script&lang=js&"
export * from "./Add-User-To-Folder.vue?vue&type=script&lang=js&"
import style0 from "./Add-User-To-Folder.vue?vue&type=style&index=0&id=769773ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769773ea",
  null
  
)

export default component.exports